import * as React from 'react'
import './Footer.scss'
import * as Common from '@tfo/common'
import { useStore } from '../../hooks/useStore'
import CookieInformation from '../disclaimer/CookieInformation'
import { Elements, enums } from '@tfo/common'
import { observer } from 'mobx-react'
import LaunchIcon from '@material-ui/icons/Launch';
const { Anchor, Heading4, Paragraph } = Elements
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import EmailIcon from '@material-ui/icons/Email';
import IconButton from '@material-ui/core/IconButton';
import { Tooltip } from '@material-ui/core'
import { useIntl } from "react-intl"
import Button from '@material-ui/core/Button';


const Footer = observer(() => {
	const { clientViewStore, userStore } = useStore()
	const company = clientViewStore.company
	const intl = useIntl()

	return (
		<div>
			<CookieInformation />
			<footer className="Footer">
				<div className='footer-decoration-container'>
					<div className='divider' />
					<Paragraph className="Footer__Text">
						{intl.formatMessage({ id: 'common.footer' })}
					</Paragraph>
					<div className='divider' />
				</div>
				<div className='footer-content-wrapper'>

					<div className='footer-links-container'>
						{Common.utils.loggedIn() && !clientViewStore.lockedMode && (
							<>
								<div className='footer-links-column'>
									<Heading4 className='footer-title'>{intl.formatMessage({ id: 'client.start.backgroundChecks' })}</Heading4>
									<Anchor className='footer-link' href={company && company?.subsidiaries?.length > 0 ? '/sub-companies' : `/service-packages/${company?.id}`}>{intl.formatMessage({ id: 'client.start.newReport.heading' })}</Anchor>
									<Anchor className='footer-link' href='/reports'>{intl.formatMessage({ id: 'client.reports.heading' })}</Anchor>
									<Anchor className='footer-link' href='/archive'>{intl.formatMessage({ id: 'client.start.archive.heading' })}</Anchor>
								</div>
								<div className='footer-links-column'>
									<Heading4 className='footer-title'>{intl.formatMessage({ id: 'client.start.accountDetails' })}</Heading4>
									<Anchor className='footer-link' href='/myaccount'>{intl.formatMessage({ id: 'common.myAccount' })}</Anchor>
									{userStore.user?.roles && userStore.user.roles[0].role == enums.CompanyUserRoles.SuperUser && (<Anchor className='footer-link' href='/myorganisation'>{intl.formatMessage({ id: 'common.myOrganisation' })}</Anchor>)}
								</div>
								<div className='footer-links-column'>
									<Heading4 className='footer-title'>{intl.formatMessage({ id: 'client.start.help' })}</Heading4>
									<Anchor className='footer-link' href={intl.formatMessage({ id: 'common.footer.policyLink' })} target='_blank' rel="noopener noreferrer">{intl.formatMessage({ id: 'client.start.policy' })}<LaunchIcon className='footer-links-launchIcon' fontSize='small' /></Anchor>
									<Anchor className='footer-link' href='/faq'>{intl.formatMessage({ id: 'client.start.faq' })}</Anchor>
									<Anchor className='footer-link' href='/general-terms'>{intl.formatMessage({ id: 'client.start.generalTerms' })}</Anchor>
								</div>
							</>
						)}

					</div>
					<div className='footer-linkIcons-container'>
						{Common.utils.loggedIn() && !clientViewStore.lockedMode && (
							<>
								<Tooltip title='LinkedIn'>
									<IconButton className='footer-linkIcons-btn' href='https://www.linkedin.com/company/tofindout-ab/' target="_blank" rel="noopener noreferrer">
										<LinkedInIcon className='footer-linkIcons-icons' fontSize='large' />
									</IconButton>
								</Tooltip>
								<Tooltip title={intl.formatMessage({ id: 'client.start.contact' })}>
									<IconButton className='footer-linkIcons-btn' href='mailto:kund@tofindout.se'>
										<EmailIcon className='footer-linkIcons-icons' fontSize='large' />
									</IconButton>
								</Tooltip>
								<Button variant="outlined" className='footer-linkIcons-feedback' href='mailto:feedback@tofindout.se'>Feedback</Button>
							</>
						)}
					</div>
				</div>
			</footer>
		</div>)
})

export default Footer
